import ManualDiscountInformationHeader from './ManualDiscountInformationHeader'

export default ManualDiscountInformationHeader
